import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"
import DatalakeService from "src/services/datalake-service"
import dayjs from "dayjs"
import { DATE_FORMAT_SHOW } from "src/utils/constants"

const ParameterDatalakeCVMObrigacoesControle = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = async () => {
        props.loading(true)

        try {
            const response = await dataLakeService.loadPaginationEndpoint(props.endpoint)
            const { results, count, next, previous } = response.body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData(list)
        } catch (error) {
            console.error("Erro ao carregar os dados:", error)
        } finally {
            props.loading(false)
        }
    }

    const createRow = async () => {
        const body = {
            "DataReferencia": null,
            "CPFCNPJ": null,
            "CategoriaRegistro": null,
            "IsCapitalAberto": null,
            "DataRegistroBolsa": null,
            "FCA_DataBase": null,
            "FCA_DataLimite": null,
            "FCA_DataEntrega": null,
            "FCA_DiasAtrasoEntrega": null,
            "FRE_ExercicioEsperado": null,
            "FRE_DataBase": null,
            "FRE_DataEntrega": null,
            "FRE_DataLimite": null,
            "FRE_DiasAtrasoEntrega": null,
            "DFP_ExercicioEsperado": null,
            "DFP_DataBase": null,
            "DFP_DataEntrega": null,
            "DFP_DataLimite": null,
            "DFP_DiasAtrasoEntrega": null,
            "ITR_DataBase": null,
            "ITR_DataEntrega": null,
            "ITR_DataLimite": null,
            "ITR_DiasAtrasoEntrega": null,
            "CGVN_DataBase": null,
            "CGVN_DataEntrega": null,
            "CGVN_DataLimite": null,
            "CGVN_DiasAtrasoEntrega": null,
            "AGO_DataBase": null,
            "AGO_DataEntrega": null,
            "AGO_DataLimite": null,
            "AGO_DiasAtrasoEntrega": null,
            "Status_EGEM": null,
            "Status_EFRF": null,
            "AdimplenteBalanco": null,
            "AdimplenteCVM": null
        }


        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData()
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID, DataReferencia, CPFCNPJ, CategoriaRegistro, IsCapitalAberto, DataRegistroBolsa, FCA_DataBase, FCA_DataLimite,
            FCA_DataEntrega, FCA_DiasAtrasoEntrega, FRE_ExercicioEsperado, FRE_DataBase, FRE_DataEntrega,
            FRE_DataLimite, FRE_DiasAtrasoEntrega, DFP_ExercicioEsperado, DFP_DataBase, DFP_DataEntrega,
            DFP_DataLimite, DFP_DiasAtrasoEntrega, ITR_DataBase, ITR_DataEntrega, ITR_DataLimite, ITR_DiasAtrasoEntrega, CGVN_DataBase, CGVN_DataEntrega,
            CGVN_DataLimite, CGVN_DiasAtrasoEntrega, AGO_DataBase, AGO_DataEntrega, AGO_DataLimite, AGO_DiasAtrasoEntrega, Status_EGEM, Status_EFRF,
            AdimplenteBalanco, AdimplenteCVM
        } = newRow

        const body = {
            "DataReferencia": DataReferencia,
            "CPFCNPJ": CPFCNPJ,
            "CategoriaRegistro": CategoriaRegistro,
            "IsCapitalAberto": IsCapitalAberto,
            "DataRegistroBolsa": DataRegistroBolsa,
            "FCA_DataBase": FCA_DataBase,
            "FCA_DataLimite": FCA_DataLimite,
            "FCA_DataEntrega": FCA_DataEntrega,
            "FCA_DiasAtrasoEntrega": FCA_DiasAtrasoEntrega,
            "FRE_ExercicioEsperado": FRE_ExercicioEsperado,
            "FRE_DataBase": FRE_DataBase,
            "FRE_DataEntrega": FRE_DataEntrega,
            "FRE_DataLimite": FRE_DataLimite,
            "FRE_DiasAtrasoEntrega": FRE_DiasAtrasoEntrega,
            "DFP_ExercicioEsperado": DFP_ExercicioEsperado,
            "DFP_DataBase": DFP_DataBase,
            "DFP_DataEntrega": DFP_DataEntrega,
            "DFP_DataLimite": DFP_DataLimite,
            "DFP_DiasAtrasoEntrega": DFP_DiasAtrasoEntrega,
            "ITR_DataBase": ITR_DataBase,
            "ITR_DataEntrega": ITR_DataEntrega,
            "ITR_DataLimite": ITR_DataLimite,
            "ITR_DiasAtrasoEntrega": ITR_DiasAtrasoEntrega,
            "CGVN_DataBase": CGVN_DataBase,
            "CGVN_DataEntrega": CGVN_DataEntrega,
            "CGVN_DataLimite": CGVN_DataLimite,
            "CGVN_DiasAtrasoEntrega": CGVN_DiasAtrasoEntrega,
            "AGO_DataBase": AGO_DataBase,
            "AGO_DataEntrega": AGO_DataEntrega,
            "AGO_DataLimite": AGO_DataLimite,
            "AGO_DiasAtrasoEntrega": AGO_DiasAtrasoEntrega,
            "Status_EGEM": Status_EGEM,
            "Status_EFRF": Status_EFRF,
            "AdimplenteBalanco": AdimplenteBalanco,
            "AdimplenteCVM": AdimplenteCVM,
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)

        try {
            const response = await dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset)
            const { results, count, next, previous } = response.body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData(list)
        } catch (error) {
            console.error("Erro ao filtrar os dados:", error)
        } finally {
            props.loading(false)
        }
    }

    const changePage = async (endpoint) => {
        props.loading(true)

        try {
            const response = await dataLakeService.paginate(endpoint)
            const { results, count, previous, next } = response.body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData(list)
        } catch (error) {
            console.error("Erro ao alterar a página:", error)
        } finally {
            props.loading(false)
        }
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'DataReferencia',
            headerName: 'Data Referência',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'CPFCNPJ',
            headerName: 'CPF/CNPJ',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CategoriaRegistro',
            headerName: 'Categoria Registro',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'IsCapitalAberto',
            headerName: 'IsCapitalAberto',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataRegistroBolsa',
            headerName: 'Data Registro Bolsa',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'FCA_DataBase',
            headerName: 'FCA_DataBase',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'FCA_DataLimite',
            headerName: 'FCA_DataLimite',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'FCA_DataEntrega',
            headerName: 'FCA_DataEntrega',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'FCA_DiasAtrasoEntrega',
            headerName: 'FCA_DiasAtrasoEntrega',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FRE_ExercicioEsperado',
            headerName: 'FRE_ExercicioEsperado',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'FRE_DataBase',
            headerName: 'FRE_DataBase',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'FRE_DataEntrega',
            headerName: 'FRE_DataEntrega',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'FRE_DataLimite',
            headerName: 'FRE_DataLimite',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'FRE_DiasAtrasoEntrega',
            headerName: 'FRE_DiasAtrasoEntrega',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DFP_ExercicioEsperado',
            headerName: 'DFP_ExercicioEsperado',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'DFP_DataBase',
            headerName: 'DFP_DataBase',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'DFP_DataEntrega',
            headerName: 'DFP_DataEntrega',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'DFP_DataLimite',
            headerName: 'DFP_DataLimite',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'DFP_DiasAtrasoEntrega',
            headerName: 'DFP_DiasAtrasoEntrega',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'ITR_DataBase',
            headerName: 'ITR_DataBase',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'ITR_DataEntrega',
            headerName: 'ITR_DataEntrega',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'ITR_DataLimite',
            headerName: 'ITR_DataLimite',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'ITR_DiasAtrasoEntrega',
            headerName: 'ITR_DiasAtrasoEntrega',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CGVN_DataBase',
            headerName: 'CGVN_DataBase',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'CGVN_DataEntrega',
            headerName: 'CGVN_DataEntrega',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'CGVN_DataLimite',
            headerName: 'CGVN_DataLimite',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'CGVN_DiasAtrasoEntrega',
            headerName: 'CGVN_DiasAtrasoEntrega',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AGO_DataBase',
            headerName: 'AGO_DataBase',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'AGO_DataEntrega',
            headerName: 'AGO_DataEntrega',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'AGO_DataLimite',
            headerName: 'AGO_DataLimite',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'AGO_DiasAtrasoEntrega',
            headerName: 'AGO_DiasAtrasoEntrega',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'number',
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Status_EGEM',
            headerName: 'Status_EGEM',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Status_EFRF',
            headerName: 'Status_EFRF',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AdimplenteBalanco',
            headerName: 'AdimplenteBalanco',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AdimplenteCVM',
            headerName: 'AdimplenteCVM',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterDatalakeCVMObrigacoesControle.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakeCVMObrigacoesControle
